import debounce from 'lodash/debounce';
import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import { waitFor } from '../../Shared/js/utils/timer';
import AddressSearch from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';

    async function main() {
        var searchPage = wo$('[data-search-page]');
        if (!searchPage.length) return;

        var searchController = {
            init: async function () {
                searchController.registerNotifications();
                searchController.initHistoryTracker();
                searchController.loadSearchModal();
                searchController.trackPage(false);
                WhistleOut.getAds('MobilePhones');

                if (wo$('[data-coverage-maps]').length) {
                    await waitFor(() => !!WhistleOut.CoverageMap);
                    if (WhistleOut.CoverageMap) {
                        WhistleOut.CoverageMap.init(wo$('body'));
                    }
                }

                WhistleOut.bindCitiesAutoComplete(wo$('body'));
                wo$('a[data-action="scroll-top"]').click(function () {
                    WhistleOut.scrollTo(0);
                    return false;
                });
            },

            registerNotifications: function () {
                // WARNING: jQuery.Callbacks() doesn't seem to support async functions
                WhistleOut.notifications.add((notification, data) => {
                    if (data && data.criteria && data.type !== 'Page') {
                        data.criteria.page = 1;
                    }

                    switch (notification) {
                        case 'FilterChanged':
                            this.onFilterChanged(data);
                            break;

                        case 'TabChanged':
                            this.onTabChanged(data);
                            break;

                        case 'SearchResultsRendered':
                            this.onSearchResultsRendered(data).then();
                            break;

                        default:
                            break;
                    }
                });
            },

            onFilterChanged: data => {
                wo$('[data-enable-when-ready]').attr('disabled', 'disabled');

                var renderFilters = data.type === 'Lines' || data.criteria.lines.length > 1;
                var fullReload = data.type === 'Page';
                if (wo$('[data-search-page]').data('search-page') === 'redirect') {
                    fullReload = true;
                    // Reset result flags when redirecting from embedded to full results
                    data.criteria.hideShare = false;
                    data.criteria.hideCoverage = false;
                    data.criteria.hideCoverageStrip = false;
                    data.criteria.hideWidenResults = false;

                    if (
                        !data.criteria.address ||
                        data.criteria.address.toLowerCase() === 'australia' ||
                        data.criteria.address.toLowerCase() === 'united states'
                    ) {
                        WhistleOut.getCurrentLocation(
                            function (e) {
                                var address = e.label;
                                if (address.length > 1) {
                                    data.criteria.address = address;
                                }
                                searchController.updateFilters(data.criteria, renderFilters, fullReload);
                            },
                            function () {
                                searchController.updateFilters(data.criteria, renderFilters, fullReload);
                            }
                        );
                    } else {
                        searchController.updateFilters(data.criteria, renderFilters, fullReload);
                    }
                } else {
                    searchController.updateFilters(data.criteria, renderFilters, fullReload);
                }
            },

            onTabChanged: data => {
                var queryString = '?' + WhistleOut.MobilePhones.generateQueryString(data.criteria);
                searchController.HistoryWrapper.pushQuery(queryString);
                searchController.loadSearchModal();
            },

            onSearchResultsRendered: async data => {
                searchController.loadSearchModal();
                searchController.trackPage(data.isAjax);
                WhistleOut.getAds('MobilePhones');

                if (wo$('[data-coverage-maps]').length) {
                    await waitFor(() => !!WhistleOut.CoverageMap);
                    if (WhistleOut.CoverageMap) {
                        WhistleOut.CoverageMap.init(wo$('body'));
                    }
                }

                wo$(window).resize();
            },

            loadSearchModal: function () {
                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                var modalUrl =
                    criteria.lines.length > 1 ? criteria.multiLineModalAjaxUrl : criteria.singleLineModalAjaxUrl;

                wo$.ajax({
                    url: modalUrl + window.location.search,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#filters-modal-partial');
                        $results.html(result);
                        WhistleOut.notifications.fire('FiltersModalReady');
                    }
                });
            },

            trackPage: function (isAjax) {
                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                var resultCount = wo$('#search-results-partial').find('[data-result-count]').data('result-count');

                var currentSupplierId =
                    criteria.currentsupplierid && criteria.currentsupplierid > 0 ? criteria.currentsupplierid : null;

                var values = [];
                values.push(currentSupplierId);
                values.push(criteria.minSpend);
                values.push(criteria.maxSpend);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].data : null);
                values.push(
                    criteria.lines.length === 1
                        ? criteria.lines[0].calls
                            ? criteria.lines[0].calls
                            : criteria.lines[0].minutes
                        : null
                );
                values.push(criteria.lines.length === 1 ? criteria.lines[0].sms : null);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].phone : null);
                values.push(criteria.dealsonly);
                values.push(criteria.sortExpression);
                values.push(criteria.sortAscending);
                values.push(criteria.maxupfront > -1 ? criteria.maxupfront : null);
                values.push(resultCount);
                values.push(criteria.lines.length);
                var valuesString = values.join('|');

                WhistleOut.trackPageView(null, valuesString, isAjax);

                if (isAjax) {
                    var phone = '';
                    var phoneBrand = '';
                    if (criteria.lines.length === 1) {
                        if (criteria.lines[0].phone) {
                            phone = criteria.lines[0].phone;
                            phoneBrand = criteria.lines[0].phoneManufacturer;
                        } else if (criteria.lines[0].simOnly === true) {
                            phone = 'BYO';
                        }
                    }

                    var remarketing = {
                        supplier: criteria.suppliers ? criteria.suppliers.join() : '',
                        postcode: criteria.postcode,
                        numberOfLines: criteria.lines.length,
                        data: criteria.lines.length === 1 ? criteria.lines[0].data : '',
                        phoneBrand: phoneBrand,
                        phone: phone
                    };
                    WhistleOut.remarketing(remarketing);
                }

                Cookies.set('CurrentSupplierMobilePhones', currentSupplierId == null ? '' : currentSupplierId, {
                    path: '/',
                    expires: 60
                });
            },

            updateFilters: debounce(function (criteria, reloadFilters, fullReload) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);

                var queryString = '?' + WhistleOut.MobilePhones.generateQueryString(criteria);
                if (fullReload) {
                    location.href = criteria.searchUrl + queryString;
                    WhistleOut.endProgress();
                    return;
                } else if (reloadFilters) {
                    var filtersUrl =
                        criteria.lines.length > 1
                            ? criteria.multiLineFiltersAjaxUrl
                            : criteria.singleLineFiltersAjaxUrl;
                    wo$.ajax({
                        url: filtersUrl + queryString,
                        type: 'GET',
                        success: function (result) {
                            var $filters = wo$('#search-filters-partial');
                            $filters.html(result);
                            wo$(window).resize();
                            WhistleOut.notifications.fire('SearchFiltersRendered');
                        }
                    });
                }

                var resultsUrl = criteria.lines.length > 1 ? criteria.multiLineAjaxUrl : criteria.singleLineAjaxUrl;

                const $addressBar = wo$('[data-search-address] > div');
                if ($addressBar.length > 0) {
                    unmountComponentAtNode($addressBar[0]);
                }

                wo$.ajax({
                    url: resultsUrl + queryString,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);

                        WhistleOut.applyPopover($results);

                        searchController.HistoryWrapper.pushQuery(queryString);

                        WhistleOut.endProgress();

                        WhistleOut.notifications.fire('SearchResultsRendered', { criteria: criteria, isAjax: true });

                        const nodeToAttach = $results.find('[data-search-address]');
                        if (nodeToAttach.length > 0) {
                            render(
                                createElement(AddressSearch, nodeToAttach.data('search-address')),
                                nodeToAttach.find('div')[0]
                            );
                        }

                        wo$(window).resize();
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            }, 300),

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(searchController);
            }
        };

        await searchController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
